const getLaborTicketsLoading = (state) => {
  return state?.workOrderManagement?.laborTicketsLoading ?? false;
};

export { getLaborTicketsLoading };
